import { values } from 'lodash-es';
import { useMemo } from 'react';
import { CustomerBalanceTransactionStatusEnum } from '../../../../types';
import { prettyName } from '../../../../utils';
import { IconName } from '../../../Icons';
import type { FilterableProperty } from '../types';

/**
 * This hook creates the filter property definition for CustomerBalanceTransactionStatusEnums properties.
 *
 * @returns Filter Property definition to use for CustomerBalanceTransactionStatusEnums filters
 */

export function useCustomerTransactionStatusesFilter() {
  return useMemo(
    () =>
      ({
        key: 'Statuses',
        label: 'Status',
        icon: IconName.CheckCircle,
        options: values(CustomerBalanceTransactionStatusEnum),
        getOptionLabel: value => prettyName(value),
      }) as const satisfies FilterableProperty,
    []
  );
}
